var exports = {
  "Q": "xa15a2ab7--415f76--content",
};

module.exports = exports;
